module.exports = __webpack_public_path__ + "img/Habitat-Learn-Logo-Colour.45a5ff7e.svg";